import Surveys from './components/Surveys';

export default Surveys;
